<template>
	<div>
		<listado v-if="accion == 'listado'" :on-editar="onEditar" :on-crear="onCrear" :key="time"></listado>
		<editar v-if="accion == 'editar'" :cliente="cliente" :on-cerrar="onCerrar" :key="time"></editar>
		<crear-simple v-if="accion == 'simple'" :clientes="clientes" :on-cerrar="onCerrar" :key="time"></crear-simple>
		<crear-masivo v-if="accion == 'masivo'" :clientes="clientes" :on-cerrar="onCerrar" :key="time"></crear-masivo>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import Listado from "./listado.vue"
	import Editar from "./editar.vue"
	import CrearSimple from "./crear_simple.vue"
	import CrearMasivo from "./crear_masivo.vue"


	export default 
	{
		name: "Clientes",
		components: { Listado, Editar, CrearSimple, CrearMasivo },
		props: {
			menu: String // Variable que guarda el menu seleccionado
		},
		data() {
			return {
				periodo: "",
				time: 0,
				accion: "listado",
				clientes: [],
				cliente: {},
			}
		},
		created() {

			this.time = Date.now()
		},
		mounted: function() {

			const that = this

			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})
		},
		methods: {

			onEditar(id) {

				window.event.$emit("mostrar-cargando", true)

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "man0",
					"proceso": "cli2admindetail",
					"cliente": {
						"_id": id
					}
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.cliente = response.data.data
					this.time = Date.now()
					this.accion = 'editar'

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				}).catch(ex => {

					this.mensaje = ex.message

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},

			onCrear(tipo, clientes) {

				this.time = Date.now()
				this.accion = tipo
				this.clientes = clientes
			},

			onCerrar() {

				this.time = Date.now()
				this.accion = 'listado'
			}
		}
	}

</script>
